export default function RequestStats({ available , total }) {
    return (
        <div className="grid grid-cols-3 gap-3 mt-4">
            <div className="bg-gradient-to-br from-teal-500 to-teal-600 text-white rounded-xl p-4 shadow-sm">
                <p className="text-xs opacity-90">Available Requests</p>
                <p className="text-2xl font-bold mt-1">{available}</p>
            </div>
            <div className="bg-gradient-to-br from-emerald-500 to-green-600 text-white rounded-xl p-4 shadow-sm">
                <p className="text-xs opacity-90">Total Today</p>
                <p className="text-2xl font-bold mt-1">{total}</p>
            </div>
        </div>
    );
}